import { type ThemeOptions, createTheme } from '@mui/material'

import { commonThemeOptions } from './commonThemeOptions'

const legacyHubloThemeOptions: Partial<ThemeOptions> = {}

export const legacyHubloTheme = createTheme(
  commonThemeOptions,
  legacyHubloThemeOptions,
)

// Never do directly "legacyHubloTheme.something = {}" because it will erase commonThemeOptions
